import React from 'react';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class CreateTourProductItems extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div className="mb0 mt40" id={"create-tour-product-items"}>
                {/*<h3 className={"mb0 mt40"} >7. 여행상품 아이템 생성 API</h3>*/}
                <h3 className={"mb0 mt40"} >상품 옵션 등록</h3>

                <div className="blog-post-meta">
                    <span className="s-post">쿠팡에서 판매할 상품의 옵션을 등록하는 API입니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">POST</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tours/{'{travelProductId}'}/items</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tours/1234567890/items
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>sellerTravelItemId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>셀러 여행 아이템 id</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>name</td>
                            <td>X</td>
                            <td>String</td>
                            <td>여행 아이템 명. (최대 문자열 길이는 50자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>onSale</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>판매 중:true, 판매중지:false</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>description</td>
                            <td>X</td>
                            <td>String</td>
                            <td>여행 아이템 설명 (최대 문자열 길이는 2000자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>period</td>
                            <td>X</td>
                            <td>String</td>
                            <td>여행 아이템의 여행기간</td>
                        </tr>

                        <tr>
                            <td colSpan={level1}>contents</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>title</td>
                            <td>X</td>
                            <td>String</td>
                            <td>여행상품 컨텐츠 타이틀</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>컨텐츠 타입에 대한 자유텍스트 입력. 예:패키지 투어</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>content</td>
                            <td>X</td>
                            <td>String</td>
                            <td>'이미지' 포맷이 아닌 경우 선택, '이미지'이면 필수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>format</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>IMAGE</td>
                                        <td>IMAGE</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrl</td>
                            <td>X</td>
                            <td>String</td>
                            <td>'이미지'포맷인 경우 sellerUrl 이 image url 이며 필수임, 그 외 선택
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>Http method(GET/POST), default GET.</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>컨텐츠 순서</td>
                        </tr>

                        <tr>
                            <td colSpan={level1}>itineraries</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>name</td>
                            <td>O</td>
                            <td>String</td>
                            <td>여행일정 제목</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>notice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>일정에 관한 공지사항</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>courses</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>name</td>
                            <td>O</td>
                            <td>String</td>
                            <td>세부일정 제목 예) 1일차</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>summary</td>
                            <td>X</td>
                            <td>String</td>
                            <td>세부일정 요약</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>from</td>
                            <td>X</td>
                            <td>String</td>
                            <td>출발지</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>to</td>
                            <td>X</td>
                            <td>String</td>
                            <td>목적지</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>details</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>HOTEL,
                                FLIGHT,
                                MEAL,
                                SIGHTSEEING,
                                SHOPPING,
                                NOTICE
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>mealName</td>
                            <td>X</td>
                            <td>String</td>
                            <td>식사 제목</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>location</td>
                            <td>X</td>
                            <td>String</td>
                            <td>장소</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>flightFrom</td>
                            <td>X</td>
                            <td>String</td>
                            <td>항공기 출발지</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>flightTo</td>
                            <td>X</td>
                            <td>String</td>
                            <td>항공기 목적지</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>flightDepartureTime</td>
                            <td>X</td>
                            <td>String</td>
                            <td>항공기 출발시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>flightArrivalTime</td>
                            <td>X</td>
                            <td>String</td>
                            <td>항공기 도착시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>duration</td>
                            <td>X</td>
                            <td>String</td>
                            <td>소요시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>distance</td>
                            <td>X</td>
                            <td>String</td>
                            <td>거리</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>descriptions</td>
                            <td>X</td>
                            <td>Array</td>
                            <td></td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;title</td>
                            <td>O</td>
                            <td>String</td>
                            <td>세부일정 내용 타이틀</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>컨텐츠 타입 자유텍스트 입력</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;content</td>
                            <td>X</td>
                            <td>String</td>
                            <td>세부일정 내용(‘이미지’포맷이 아닌 경우 선택, 이미지이면 필수)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;format</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TEXT</td>
                                        <td>TEXT 디폴트 값</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;sellerUrl</td>
                            <td>X</td>
                            <td>String</td>
                            <td>‘이미지’포맷인 경우 sellerUrl 이 image url 이며 필수임, 그 외 선택</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                Http method(GET/POST), default GET.
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>&emsp;&emsp;seq</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>서부일정 내용 순서</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>seq</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>세부일정 순서</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>feeIncluded</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>요금 포함여부</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>optional</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>일정 자유선택 여부</td>
                        </tr>

                        <tr>
                            <td colSpan={level1}>seq</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>여행 아이템 순서</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>features</td>
                            <td></td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>featureId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>Feature 관련 세부 사항은 엑셀 파일 참조 하시기 바랍니다</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>featureValues</td>
                            <td>X</td>
                            <td>List{'<String>'}</td>
                            <td>Feature 관련 세부 사항은 엑셀 파일 참조 하시기 바랍니다</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>description</td>
                            <td>X</td>
                            <td>String</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>taxType</td>
                            <td>X</td>
                            <td>TaxType</td>
                            <td>
                                *travelType이 OVERSEAS인 경우 taxType이 자동으로 면세(FREE)로 설정되며, 이외의 taxType를 설정 할 수 없습니다.
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TAX</td>
                                        <td>과세 (기본값)</td>
                                    </tr>
                                    <tr>
                                        <td>FREE</td>
                                        <td>면세</td>
                                    </tr>
                                    <tr>
                                        <td>ZERO</td>
                                        <td>영세</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>rates</td>
                            <td>O</td>
                            <td>List{'<TourRate>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerRateId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>셀러 rate id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>rateType</td>
                            <td>O</td>
                            <td>TourRateType</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>BASIC</td>
                                        <td>기본</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT_DAEIN_AND_CHILD_SOIN</td>
                                        <td>대인/소인동일</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT</td>
                                        <td>성인</td>
                                    </tr>
                                    <tr>
                                        <td>ADULT_DAEIN</td>
                                        <td>대인</td>
                                    </tr>
                                    <tr>
                                        <td>UNIVERSITY_STUDENT</td>
                                        <td>대학생</td>
                                    </tr>
                                    <tr>
                                        <td>HIGH_SCHOOL_STUDENT</td>
                                        <td>고등학생</td>
                                    </tr>
                                    <tr>
                                        <td>MIDDLE_SCHOOL_STUDENT</td>
                                        <td>중학생</td>
                                    </tr>
                                    <tr>
                                        <td>SCHOOL_CHILD</td>
                                        <td>초등학생</td>
                                    </tr>
                                    <tr>
                                        <td>HIGH_AND_MIDDLE_SCHOOL_STUDENT</td>
                                        <td>중고생</td>
                                    </tr>
                                    <tr>
                                        <td>ELEMENTARY_MIDDLE_AND_HIGH_SCHOOL_STUDENT</td>
                                        <td>초중고생</td>
                                    </tr>
                                    <tr>
                                        <td>TEENS</td>
                                        <td>청소년</td>
                                    </tr>
                                    <tr>
                                        <td>STUDENT</td>
                                        <td>학생</td>
                                    </tr>
                                    <tr>
                                        <td>PRESCHOOL_CHILD</td>
                                        <td>미취학아동</td>
                                    </tr>
                                    <tr>
                                        <td>CHILD</td>
                                        <td>아동</td>
                                    </tr>
                                    <tr>
                                        <td>CHILD_SOIN</td>
                                        <td>소인</td>
                                    </tr>
                                    <tr>
                                        <td>TODDLER</td>
                                        <td>유아</td>
                                    </tr>
                                    <tr>
                                        <td>INFANT</td>
                                        <td>영아</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>priceType</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TOTAL_PRODUCT_PRICE</td>
                                        <td>총 상품 가격</td>
                                    </tr>
                                    <tr>
                                        <td>OWN_COMPANY_PRICE</td>
                                        <td>자사 홈페이지가</td>
                                    </tr>
                                    <tr>
                                        <td>OWN_COMPANY_MALL_SALE_PRICE</td>
                                        <td>자사몰 판매가</td>
                                    </tr>
                                    <tr>
                                        <td>ONLINE_SALE_PRICE</td>
                                        <td>온라인 판매가</td>
                                    </tr>
                                    <tr>
                                        <td>TRAVEL_AGENCY_SPECIAL_PRICE</td>
                                        <td>여행사 특가</td>
                                    </tr>
                                    <tr>
                                        <td>RESERVATION_SALE_PRICE</td>
                                        <td>예매처 판매가</td>
                                    </tr>
                                    <tr>
                                        <td>HOMEPAGE_SALE_PRICE</td>
                                        <td>홈페이지 판매가</td>
                                    </tr>
                                    <tr>
                                        <td>SITE_SALE_PRICE</td>
                                        <td>현장 판매가</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>price</td>
                            <td>X</td>
                            <td>BigDecimal</td>
                            <td>판매 원가</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>representative</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>Default: TRUE</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>saleStartedAt</td>
                            <td>O</td>
                            <td>LocalDateTime</td>
                            <td>판매노출 시작일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>saleEndedAt</td>
                            <td>X</td>
                            <td>LocalDateTime</td>
                            <td>판매노출 종료일 (yyyy-MM-dd HH:mm:ss). Default: 2099-12-31 23:59:59</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>maxPurchaseQtyPerPerson</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>인당 최대 구매 개수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>maxPurchaseQtyPeriod</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>구매 제한 기간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>여행 아이템 순서</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#postItemDto">Request Body</a>
                        </div>
                        <div id = "postItemDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
            {
                "sellerTravelItemId": "seller-item-id-2",
                "name": "[장사/장가계] 4박6일",
                "description": "[장사/장가계] 4박6일 description",
                "period": "4박6일",
                "seq": 1,
                "features": [],
                "taxType": "FREE",
                "onSale": true,
                "rates": [
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "ADULT",
                        "priceType": "COUPANG_PRICE",
                        "price": 50000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 0
                    },
                    {
                        "sellerRateId": "seller-rate-id-1",
                        "rateType": "CHILD",
                        "priceType": "COUPANG_PRICE",
                        "price": 40000000,
                        "representative": true,
                        "saleStartedAt": "2019-11-01 01:00:00",
                        "saleEndedAt": "2019-12-21 01:00:00",
                        "maxPurchaseQtyPerPerson": 10,
                        "maxPurchaseQtyPeriod": 1,
                        "seq": 1
                    }
                ]
            }
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td>travelItemId</td>
                            <td>Long</td>
                            <td>여행 아이템 id</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": 200
            "message" : "success"
            "data" : 191043228223418368
        }
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesforCreateItem">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesforCreateItem" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        <li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>
                                        <li>무효 seqs</li>
                                        <li>무효 tour item feature id</li>
                                        <li>무효 tour item feature value</li>
                                        <li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>
                                        <li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V1/ProductAPI/CreateTourProductItems.jsx